import * as React from 'react';

function DatePickerIcon(props) {
    const { color = '#FFF' } = props;
    return (
        <svg width="25" height="25" viewBox="0 0 39 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30.0662 4.63281H8.13284C6.40235 4.63281 4.99951 5.52824 4.99951 6.63281V20.6328C4.99951 21.7374 6.40235 22.6328 8.13284 22.6328H30.0662C31.7967 22.6328 33.1995 21.7374 33.1995 20.6328V6.63281C33.1995 5.52824 31.7967 4.63281 30.0662 4.63281Z" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25.3662 2.63281V6.63281" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.833 2.63281V6.63281" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.99951 10.6328H33.1995" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default DatePickerIcon;
